import { render, staticRenderFns } from "./CampaignSetupPixelsPlatform.vue?vue&type=template&id=2a8c2aaa&"
import script from "./CampaignSetupPixelsPlatform.vue?vue&type=script&lang=js&"
export * from "./CampaignSetupPixelsPlatform.vue?vue&type=script&lang=js&"
import style0 from "./CampaignSetupPixelsPlatform.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports